<template>
  <section class="containerSkeletonOpportunityForm">
    <div class="containerSkeletonOpportunityForm__title"></div>
    <div class="containerSkeletonOpportunityForm__content">
      <div class="containerSkeletonOpportunityForm__formWrapper">
        <div class="containerSkeletonOpportunityForm__formWrapper--titleInput" v-for="index in 2" :key="index">
          <div class="titleInput__label"></div>
          <div class="titleInput__input"></div>
        </div>
        <div class="containerSkeletonOpportunityForm__formWrapper--titleInput opportunity__input">
          <div class="titleInput__label"></div>
          <div class="titleInput__input"></div>
        </div>
        <div class="containerSkeletonOpportunityForm__formWrapper--dates">
          <div class="date" v-for="index in 3" :key="index">
            <div class="date__title"></div>
            <div class="date__input"></div>
          </div>
        </div>
        <div class="containerSkeletonOpportunityForm__formWrapper--titleInput roles__input">
          <div class="titleInput__label"></div>
          <div class="titleInput__input"></div>
        </div>
        <div class="containerSkeletonOpportunityForm__formWrapper--description">
          <div class="description__title"></div>
          <div class="description__toolbar"></div>
          <div class="description__textarea"></div>
          <div class="description__wordCount"></div>
        </div>
        <div class="containerSkeletonOpportunityForm__formWrapper--tags" v-for="index in 2" :key="index">
          <div class="tags__label"></div>
          <div class="tags__input"></div>
        </div>
        <div class="containerSkeletonOpportunityForm__formWrapper--tags author__input">
          <div class="tags__label"></div>
          <div class="tags__input"></div>
        </div>
      </div>
      <div class="containerSkeletonOpportunityForm__publish">
        <div class="containerSkeletonOpportunityForm__publishWrapper">
          <div class="containerSkeletonOpportunityForm__publishWrapper--title"></div>
          <div class="containerSkeletonOpportunityForm__publishWrapper--divisor"></div>
          <div class="containerSkeletonOpportunityForm__publishWrapper--options">
            <div class="options__item">
              <div class="options__item--label"></div>
              <div class="options__item--value"></div>
            </div>
            <div class="options__item">
              <div class="options__item--label"></div>
              <div class="options__item--value"></div>
            </div>
            <div class="options__item">
              <div class="options__item--label"></div>
              <div class="options__item--value"></div>
            </div>
          </div>
          <div class="containerSkeletonOpportunityForm__publishWrapper--divisor"></div>
          <div class="containerSkeletonOpportunityForm__publishWrapper--buttons">
            <div class="buttons__draft"></div>
            <div class="buttons__publish"></div>
          </div>
        </div>
        <div class="containerSkeletonOpportunityForm__imageWrapper">
          <div class="containerSkeletonOpportunityForm__imageWrapper--title"></div>
          <div class="containerSkeletonOpportunityForm__imageWrapper--divisor"></div>
          <div class="containerSkeletonOpportunityForm__imageWrapper--image">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'skeletonOpportunityForm'
}
</script>
